import Icon from '../components/Icon.vue'

Icon.register({
  'theater-masks': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M206.9 245.2l-7.6 43.2c-21.1 7.2-38.5 18.2-49.9 30.9-2.4-32.9 21.7-63.7 57.5-74.1zM95.8 295c5.9 33.2 64.3 71.8 111.9 84.8 10.6 27.1 26 50.5 39.5 67.6-3.3 0.3-6.4 0.8-10 0.8-68.1 0-190.2-61.6-204.4-142.1l-31.7-179.5c-5-28.1 8-56.1 32.2-69.5 67.8-37.6 143.5-57.1 220.1-57.1 23.9 0 47.9 1.9 71.9 5.7 17.3 2.8 31.8 13 41.8 27-19.1 0.8-38.3 2.3-57.2 5.3-19.9 3.2-37.6 12.5-51.6 26-1.6 0-3.2-0.2-4.8-0.2-65.9 0-131.3 17-189 49 0 0-0.5 1-0.2 2.7zM193.4 157.5c3.8 21.7-10.7 42.4-32.4 46.2-21.8 3.8-42.5-10.7-46.3-32.4-0.7-4.1-0.6-8.2-0.1-12.1 10.8 5.6 24.8 7.8 39.5 5.2 14.7-2.6 27.1-9.4 35.3-18.3 1.8 3.5 3.3 7.3 4.1 11.4zM606.8 120.9c24.2 13.4 37.1 41.4 32.2 69.5l-31.7 179.5c-15.4 87.1-156.8 151.9-219.9 140.8-63-11.1-173.7-120.3-158.3-207.3l31.7-179.5c5-28.1 26.7-50 54-54.4 100.5-16.1 203 2 292 51.4zM333.6 217.7c-0.7 4.1-0.6 8.2-0.1 12.1 10.8-5.6 24.8-7.8 39.5-5.2 14.7 2.6 27.1 9.4 35.3 18.3 1.8-3.5 3.3-7.3 4.1-11.4 3.8-21.7-10.7-42.4-32.4-46.2-21.8-3.8-42.5 10.7-46.3 32.4zM404 416.5c55.7 9.8 108.2-23.8 122.4-75.7-28.1 17-68.7 24.2-111.9 16.6-43.3-7.6-78.9-28.2-99.5-53.8-4.5 53.6 33.4 103.1 89 112.9zM534.3 265.1c1.8-3.5 3.3-7.3 4.1-11.4 3.8-21.7-10.7-42.4-32.5-46.2-21.8-3.8-42.5 10.7-46.3 32.4-0.7 4.1-0.6 8.2-0.1 12.1 10.8-5.6 24.8-7.8 39.5-5.2 14.7 2.6 27.1 9.4 35.3 18.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/theater-masks.js
// module id = 1997
// module chunks = 0